import {WorkingTimeType} from "@/shared/timr";
import {CompensationType, DurationUnit, WorkingTimeTypeCategory} from "@/shared/timrTypes";

/**
 * If changing the logic in this class,
 * please also check the java equivalent WorkingTImeTypeCreditabilityCompensationUtil.java
 */
export class WorkingTimeTypeCreditabilityCompensationUtil {

	/**
	 * Returns the non-creditable deductible based on the compensation type.
	 *
	 * @return If the compensationType is null, it returns the value of
	 * 		   nonCreditableDeductible or 0
	 * 		   if nonCreditableDeductible is null.
	 *         Otherwise, it returns 0.
	 */
	public static getNonCreditableDeductible(workingTimeType: WorkingTimeType) {
		if (this.isPaidTimeOffInMinutes(workingTimeType)) {
			// For paid time off in minutes, the non-creditable deductible is 0
			return 0;
		} else {
			// If the compensation type is null, return the non-creditable deductible
			// Otherwise, return 0
			return !workingTimeType.compensationType ? workingTimeType.nonCreditableDeductible : 0;
		}
	}

	/**
	 * Returns the compensation deductible based on the compensation type.
	 *
	 * @return If the compensationType is null,
	 * 		   it returns the value of nonCreditableDeductible or 0
	 * 		   if compensationDeductible is null.
	 *         If the compensationType is CompensationType.WITH_DURATION_DEDUCTIBLE,
	 *         it returns compensationDeductible, otherwise it returns 0.
	 */
	public static getCompensationDeductible(workingTimeType: WorkingTimeType) {
		switch (workingTimeType.compensationType) {
			// If the compensation type is WITH_DURATION_DEDUCTIBLE, return the compensation deductible
			case CompensationType.WITH_DURATION_DEDUCTIBLE:
				return workingTimeType.compensationDeductible;
			// For other compensation types, return 0
			case CompensationType.FULL:
			case CompensationType.FULL_WITH_DAILY_NORMAL_WORKING_TIME_ONLY:
			case CompensationType.WITH_PERCENTAGE_CREDITABILITY:
			case CompensationType.WITH_PERCENTAGE_CREDITABILITY_OUTSIDE_DAILY_NORMAL_WORKING_TIME:
			case CompensationType.FULL_OUTSIDE_DAILY_NORMAL_WORKING_TIME:
				return 0;
			// If the compensation type is null, return the non-creditable deductible
			default:
				return workingTimeType.nonCreditableDeductible;
		}
	}

	private static isPaidTimeOffInMinutes(workingTimeType: WorkingTimeType): boolean {
		return workingTimeType.editUnit === DurationUnit.Minutes
			&& workingTimeType.category === WorkingTimeTypeCategory.PaidTimeOff;
	}
}
